import React from 'react';
import { Link } from 'react-router-dom';
import { FaLaptopCode, FaCubes, FaFlask, FaMobileAlt, FaCode, FaCheckCircle } from 'react-icons/fa';
import PageHero from '../components/PageHero';

const services = [
  {
    icon: <FaLaptopCode size={22}/>,
    title: 'Embedded Systems Design',
    desc: 'Complete hardware and firmware design for embedded applications — microcontrollers, FPGAs, real-time systems, and SoC-based platforms for industrial and automotive use.',
    points: ['Schematic & PCB design', 'MCU / FPGA selection', 'Power architecture', 'BOM optimisation'],
  },
  {
    icon: <FaMobileAlt size={22}/>,
    title: 'IoT Hardware Design',
    desc: 'Connected device design covering wireless protocols (BLE, Wi-Fi, LTE, LoRa), sensor integration, and cloud-ready hardware. Proven on Smart Meter programmes.',
    points: ['Wireless protocol design', 'Sensor integration', 'Battery optimisation', 'RF antenna design'],
  },
  {
    icon: <FaCode size={22}/>,
    title: 'Firmware Development',
    desc: 'Robust firmware engineering including RTOS, bootloaders, OTA update systems, and communication stacks. Full documentation provided.',
    points: ['RTOS development', 'Communication protocols', 'OTA update systems', 'Bootloader & security'],
  },
  {
    icon: <FaCubes size={22}/>,
    title: 'Mechanical Design',
    desc: 'Precision 3D CAD design for plastic and sheet metal enclosures — IP-rated, thermally managed, and ready for tooling and volume production.',
    points: ['3D CAD modelling', 'Plastic enclosures', 'Sheet metal parts', 'IP-rated designs'],
  },
  {
    icon: <FaFlask size={22}/>,
    title: 'Prototyping & Validation',
    desc: 'Rapid prototype builds with full electrical and mechanical validation — from EVT through DVT and PVT, with complete regulatory certification support.',
    points: ['EVT / DVT / PVT builds', 'Environmental testing', 'Regulatory support', 'DFM analysis'],
  },
  {
    icon: <FaCheckCircle size={22}/>,
    title: 'Design for Manufacturing (DFX)',
    desc: 'Design reviews and optimisation to ensure your product is manufacturable at scale — reducing cost, rework, and time-to-market with every iteration.',
    points: ['DFM / DFA analysis', 'Cost reduction reviews', 'Test coverage planning', 'Component standardisation'],
  },
];

const lifecycle = [
  { step:'01', label:'Design Validation',    items:['DFX Review', 'Schematic Sign-off', 'Component Qualification'] },
  { step:'02', label:'NPI & Proto Build',    items:['Prototype Build', 'Functional Testing', 'Design Iterations'] },
  { step:'03', label:'PCBA & Harness',       items:['PCB Assembly', 'Cable Harness', 'Test Fixture Dev'] },
  { step:'04', label:'Box Build',            items:['Product Integration', 'EOL Testing', 'Customer Packing'] },
  { step:'05', label:'Life Cycle Mgmt',      items:['Production Support', 'ECO Management', 'Repair Services'] },
];

export default function DesignServices() {
  return (
    <div>
      <PageHero
        chip="Design Services"
        title="End-to-End Electronic Design"
        subtitle="From concept sketches to production-ready designs — our engineering team at Saalfo Tech handles every stage with precision and accountability."
      />

      <section className="sec">
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <div className="g3 reveal">
            {services.map(s => (
              <div key={s.title} className="card">
                <div className="ib">{s.icon}</div>
                <h3 className="h3">{s.title}</h3>
                <p style={{ fontSize:14, color:'#64748b', lineHeight:1.65, marginBottom:16 }}>{s.desc}</p>
                <ul style={{ listStyle:'none', display:'flex', flexDirection:'column', gap:7 }}>
                  {s.points.map(p => (
                    <li key={p} style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, color:'#334155' }}>
                      <span style={{ width:5, height:5, borderRadius:'50%', background:'#5cb85c', flexShrink:0 }}/>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lifecycle */}
      <section className="sec bg-surf">
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <div style={{ marginBottom:40 }}>
            <span className="chip">Product Journey</span>
            <h2 className="h2">Our Development Lifecycle</h2>
          </div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:16 }} className="reveal">
            {lifecycle.map(l => (
              <div key={l.step} style={{ flex:'1 1 170px', minWidth:150 }}>
                <div className="card" style={{ height:'100%', position:'relative', overflow:'hidden' }}>
                  <div style={{ position:'absolute', top:10, right:14, fontFamily:'JetBrains Mono', fontSize:40, fontWeight:700, color:'#eaf6ea', lineHeight:1 }}>{l.step}</div>
                  <div className="step-dot" style={{ marginBottom:12 }}>{l.step}</div>
                  <h4 style={{ fontFamily:'Rajdhani', fontSize:17, fontWeight:700, color:'#1a1a2e', marginBottom:12 }}>{l.label}</h4>
                  <ul style={{ listStyle:'none', display:'flex', flexDirection:'column', gap:6 }}>
                    {l.items.map(it => (
                      <li key={it} style={{ fontSize:13, color:'#64748b', display:'flex', alignItems:'center', gap:6 }}>
                        <span style={{ width:4, height:4, borderRadius:'50%', background:'#5cb85c', flexShrink:0 }}/>{it}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sec-sm" style={{ textAlign:'center' }}>
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <h2 className="h2" style={{ marginBottom:10 }}>Have a design challenge?</h2>
          <p className="sub" style={{ margin:'0 auto 26px' }}>Let's find the fastest path from concept to production.</p>
          <Link to="/contact" className="btn btn-primary">Start a Conversation</Link>
        </div>
      </section>
    </div>
  );
}
